// extracted by mini-css-extract-plugin
export default {"team_card_wrapper":"Teamcard_team_card_wrapper__o0hyU","teammate_name":"Teamcard_teammate_name__NReFK","teammate_img":"Teamcard_teammate_img__H-yEf"};